import { useQuery } from "react-query";
import { getBusinessLicensePermitRenewalStatusOptions } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";
 
export const useGetBusLicensePermitRenewalStatusOptions = () => {
  return useQuery(
    "GetBusinessLicensePermitRenewalStatusOptions",
    getBusinessLicensePermitRenewalStatusOptions,
    { refetchOnWindowFocus: false }
  );
};